import { FC } from "react";
import { Button, Card, Image, Layout, Page, Stack, Text } from "@shopify/polaris";

import { card_1_image, card_2_image, card_3_image } from "../../assets/index.js";

import styles from "./OnboardingComponent.module.css";

interface OnboardingComponentProps {
  onNextStep: () => void;
}

const cards = [
  {
    title: "Hide or push down products based on their stock levels",
    firstParagraph: "With Stockhide, you’ll be able to set specific stock levels which will trigger your action on the products you choose.",
    secondParagraph: "You could, for example, hide your products that have 0 stock available or push down your collection page any product with less than 3 stock level.",
    image: card_1_image
  },
  {
    title: "Hide or push down products based on their attributes",
    firstParagraph: "You can also run your actions based on specific attributes and tags! We even support complex rulesets using AND OR operators.",
    secondParagraph: "You could, for example, push down your collection page any product that is missing a product picture and so much more!",
    image: card_2_image
  },
  {
    title: "Get timely notifications or a handy summary by email",
    firstParagraph: "Stockhide also allows you to customize your notification settings to be alerted when one of your product is out of stock (or running low).",
    secondParagraph: "You can even be alerted when a product is back and stock, and has been made visible again!",
    image: card_3_image
  }
];

const OnboardingComponent: FC<OnboardingComponentProps> = ({ onNextStep }) => {
  return (
    <Page
      title="So many features!"
      fullWidth
    >
      <div className={styles["top-right-button"]}>
        <Button
          primary
          onClick={onNextStep}
        >
          Continue
        </Button>
      </div>
      <Layout>
        <Layout.Section>
          <div className={styles["cards-wrapper"]}>
            {cards.map(card => (
              <div key={card.title} className={styles["card-wrapper"]}>
                <Card title={card.title} sectioned>
                  <div style={{ height: "100%", display: "flex" }}>
                    <Stack spacing="loose" alignment="fill" distribution="equalSpacing" vertical>
                      <Text as="p" variant="bodyMd">{card.firstParagraph}</Text>
                      <Text as="p" variant="bodyMd">{card.secondParagraph}</Text>
                      <Image source={card.image} alt={card.title} />
                    </Stack>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default OnboardingComponent;
